
















































































import Vue from 'vue';
import { ConfigurationAuthorizationModel } from '@/types';
import { ConfigurationService } from '@/services/ConfigurationService';
import MStoreDashboardButton from '@/components/shared/MStoreDashboardButton.vue';
import LoadingSpinner from '@/components/shared/LoadingSpinner.vue';

export default Vue.extend({
  name: 'ConfigurationDashboard',
  data() {
    return {
      configurationAuthorizationModel: {} as ConfigurationAuthorizationModel,
      isLoading: false
    };
  },
  async mounted(this: any) {
    this.isLoading = true;
    this.configurationAuthorizationModel = await ConfigurationService.getConfigurationAuthorizationAsync();
    this.isLoading = false;
  },
  components: {
    MStoreDashboardButton,
    LoadingSpinner
  }
});
